module.exports = __webpack_public_path__ + "media/images/play-8b3e0a574c654b131e44c948b9d45e29.svg";